// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AvatarPopup__container-af91b8 {
  border: none;
  background-color: transparent;
}

.AvatarPopup__button-b1661c {
  cursor: pointer;
  width: 100%;
  height: 100%;
  display: block;
}

.AvatarPopup__image-a6c149 {
  display: block;
  max-width: 100%;
  max-height: 100%;
  margin: auto;
  border-radius: 16px;
}`, "",{"version":3,"sources":["webpack://./../../packages/popups/src/prepared-popups/AvatarPopup/AvatarPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,6BAAA;AACF;;AAEA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;AACF","sourcesContent":[".container {\n  border: none;\n  background-color: transparent;\n}\n\n.button {\n  cursor: pointer;\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n\n.image {\n  display: block;\n  max-width: 100%;\n  max-height: 100%;\n  margin: auto;\n  border-radius: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AvatarPopup__container-af91b8`,
	"button": `AvatarPopup__button-b1661c`,
	"image": `AvatarPopup__image-a6c149`
};
module.exports = ___CSS_LOADER_EXPORT___;
